<template>
  <div>
    <div class="abg">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <img class="img-responsive" src="../assets/images/about.jpg" alt>
          </div>
          <div class="col-sm-6">
            <div class="row xs-col">
              <h1 class="text-right main-title" v-html="$t('title.about')">
                关于<em>我们</em>
                <span>About</span>
              </h1>
              <div class="about-content mb60" >
                
                <p class="text-indent" style="box-orient: vertical;-webkit-box-orient: vertical;">
                  {{aboutInfo}}
                  <!-- 湖州璟宝新型建材有限公司座落于美丽富饶的太湖南岸，是一家建材类粘结剂专业生产企业；
                  公司拥有总资产5680万元、厂房2万多平方米 ，并拥有二十多年建材粘合剂生产经验和雄厚的技
                  术实力；其主要产品木胶粉和可再分散性乳胶粉以其过硬的质量和扎实的服务而畅销全国各地和
                  东南亚地区，并赢得良好的口碑。 -->
                </p>
                <!-- <p class="text-indent visible-md visible-lg">
                  公司长期与大专院校、科研单位合作，不断研制开发各类高起点、高品质、安全环保的建材
                  类新产品以满足不断发展、不断更新的各类建筑业产品的需要；公司愿与广大新老客户携手为我
                  国建筑业的不断发展作出应有的贡献。
                </p> -->
              </div>
              <span @click="save">
 <router-link to="/about" class="more" >{{$t('more.value')}}</router-link> 
              </span>
             
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="product">
          <h1 class="text-center main-title" v-html="$t('title.product')">
            产品<em>展示</em>
            <span>Products</span>
          </h1>
          <ul class="product-sort clearfix">
            <li class="col-sm-6 col-md-3" v-for="(item,index) in product" :key="index">
              <div class="product-bg text-center">
                <img :src="item.img" class="img-circle center-block" style="width:50%;" />
                <h2>{{item.title}}</h2>
                <p>{{item.body}}</p>
                <router-link :to="'/product/dtails/'+item.id" class="more">{{$t('more.value')}}</router-link>
              </div>
            </li>
         
          </ul>
        </div>
        <div class="news">
          <h1 class="text-center main-title" v-html="$t('title.news')">
            新闻<em>资讯</em>
            <span>News</span>
          </h1>
          <ul class="clearfix news-list">
            <li class="col-sm-6" v-for="(item,index) in news" :key="index">
              <div class="box-shadow">
                <router-link :to="'/news/details/'+item.id" tag="h2">{{item.title}}</router-link>
              <p>{{item.body}}</p>
              <div><span class="news-date">{{item.addTime}}</span> <span><i class="glyphicon glyphicon-eye-open"></i> {{item.hits}}</span></div>
              </div>
              
            </li>
          
          </ul>
          <p class="text-center"><router-link to="/news" class="more">{{$t('more.value')}}</router-link></p>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "HelloWorld",
   metaInfo() {
    return {
      title: this.pageName
    }; // set a title
  },
  data() {
    return {
      news:{},
      product:{},
      aboutInfo:{}
    };
  },
  computed:{
     pageName(){
      return this.$t("mteaTitle.index");
    }
  },
  created(){
    // axios.post('http://bgyslcf.com/api/News',{
    //  id:7
    // })
    // .then((res)=>{
    //   console.log(res);
    //   //this.msg=res.data.message.title
    // })
    // .catch((error)=>{
    //   console.log(error);
    // })
     if(this.$i18n.locale == 'cn'){
      document.querySelector('meta[name="keywords"]').setAttribute('content', '乳胶粉,可再分散乳胶粉,木胶粉,网洞高分子胶粉,脲醛树脂胶粉,木工胶,脲醛树脂,木工胶粉')
      document.querySelector('meta[name="description"]').setAttribute('content', '我们是一家建材类粘结剂专业生产企业，拥有二十多年建材粘合剂生产经验和雄厚的技术实力，目前产品有乳胶粉、木胶粉、脲醛胶粉、可再分散乳胶粉、脲醛树脂胶粉、网洞高分子胶粉等，一直以来产品畅销全国各地和东南亚地区。')
    }else{
      document.querySelector('meta[name="keywords"]').setAttribute('content', 'Latex powder, redisperse latex powder, wood gum powder, net hole polymer rubber powder, urea formaldehyde resin rubber powder, wood gum, urea formaldehyde resin, carpentry rubber powder')
      document.querySelector('meta[name="description"]').setAttribute('content', 'We are a professional production enterprise of building materials binders, with more than 20 years of experience in the production of building materials adhesives and strong technical strength. At present, the products include latex powder, wood gum powder, urea-formaldehyde adhesive powder, redisperse latex powder, urea-formaldehyde resin adhesive powder, net hole polymer adhesive powder, etc.. The product has always been popular throughout the country and Southeast Asia.')
    }
  },
   mounted() {
    this.$http
      .get("http://www.hzjingbao.cn/api/topnews", {
        params: {
          lang: this.$i18n.locale,
        }
      })
      .then(res => {
        //console.log(res.data);
        this.news = res.data;
        //console.log(this.news);
      })
      .catch(erroe => {
        console.log(error);
      });

      this.$http
      .get("http://www.hzjingbao.cn/api/topproduct", {
        params: {
          lang: this.$i18n.locale,
        }
      })
      .then(res => {
        //console.log(res.data);
        this.product = res.data;
        //console.log(this.news);
      })
      .catch(erroe => {
        console.log(error);
      });

      this.$http
      .get("http://www.hzjingbao.cn/api/topproduct", {
        params: {
          lang: this.$i18n.locale,
        }
      })
      .then(res => {
       // console.log(res.data);
        this.product = res.data;
        //console.log(this.news);
      })
      .catch(erroe => {
        console.log(error);
      });
      this.$http
      .get("http://www.hzjingbao.cn/api/page", {
        params: {
          lang: this.$i18n.locale,
          type: "about"
        }
      })
      .then(res => {
        //console.log(res.data);
        var reg = /<[^>]+>/g;
        var str=res.data.body.replace(reg,"")
       // console.log(str)
        //console.log(res.data.body.replace(reg,""))
        this.aboutInfo = str.replace(/&nbsp;/ig,"");
        //alert(this.aboutInfo)
        //console.log(this.aboutInfo);
      })
      .catch(erroe => {
        console.log(error);
      });
  },
  methods:{
    save(){
     sessionStorage.setItem('aboutId','about');
     //location.reload();
    }
  }
  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue